export default "__VITE_ASSET__1d4960e4__"